export const ROLE_OPTIONS = [
  {
    label: 'Assistente',
    value: '6',
  },
  {
    label: 'Coordenador',
    value: '5',
  },
  {
    label: 'Preceptor',
    value: '8',
  },
  {
    label: 'Professor',
    value: '7',
  },
];
